'use strict';

export default {
	ACTIONS: {
		EXPORT: 'Export'
	},
	NO_RESULT: 'No results available with the current search query.',
	NO_TABLES: 'This stings like a cold cup of Joe - but there is no table with any report data present for the selected query.',
	FETCHING: 'Loading'
};